/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityPastebinResultMetadata } from './ControlEntityPastebinResultMetadata';
import {
    ControlEntityPastebinResultMetadataFromJSON,
    ControlEntityPastebinResultMetadataFromJSONTyped,
    ControlEntityPastebinResultMetadataToJSON,
} from './ControlEntityPastebinResultMetadata';

/**
 * 
 * @export
 * @interface ControlEntityPastebinResult
 */
export interface ControlEntityPastebinResult {
    /**
     * 
     * @type {string}
     * @memberof ControlEntityPastebinResult
     */
    entity_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityPastebinResult
     */
    entity_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityPastebinResult
     */
    entity_domain?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityPastebinResult
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityPastebinResult
     */
    url?: string;
    /**
     * 
     * @type {ControlEntityPastebinResultMetadata}
     * @memberof ControlEntityPastebinResult
     */
    metadata?: ControlEntityPastebinResultMetadata;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityPastebinResult
     */
    content?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlEntityPastebinResult
     */
    keywords?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityPastebinResult
     */
    found?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityPastebinResult
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityPastebinResult
     */
    updated?: string;
}

/**
 * Check if a given object implements the ControlEntityPastebinResult interface.
 */
export function instanceOfControlEntityPastebinResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityPastebinResultFromJSON(json: any): ControlEntityPastebinResult {
    return ControlEntityPastebinResultFromJSONTyped(json, false);
}

export function ControlEntityPastebinResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityPastebinResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': !exists(json, 'entity_id') ? undefined : json['entity_id'],
        'entity_name': !exists(json, 'entity_name') ? undefined : json['entity_name'],
        'entity_domain': !exists(json, 'entity_domain') ? undefined : json['entity_domain'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'metadata': !exists(json, 'metadata') ? undefined : ControlEntityPastebinResultMetadataFromJSON(json['metadata']),
        'content': !exists(json, 'content') ? undefined : json['content'],
        'keywords': !exists(json, 'keywords') ? undefined : json['keywords'],
        'found': !exists(json, 'found') ? undefined : json['found'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'updated': !exists(json, 'updated') ? undefined : json['updated'],
    };
}

export function ControlEntityPastebinResultToJSON(value?: ControlEntityPastebinResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
        'entity_name': value.entity_name,
        'entity_domain': value.entity_domain,
        'key': value.key,
        'url': value.url,
        'metadata': ControlEntityPastebinResultMetadataToJSON(value.metadata),
        'content': value.content,
        'keywords': value.keywords,
        'found': value.found,
        'created': value.created,
        'updated': value.updated,
    };
}

